/* RESPONSIBLE TEAM: team-inbox-experience */
const EXTERNAL_REPLY_SEND_STATES = {
  pending: -1,
  error: 0,
  success: 1,
};

export { EXTERNAL_REPLY_SEND_STATES };
